import { Component, NgZone } from '@angular/core';
import { StatusbarService } from '@nsk-app/services/statusbar.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public useJeepSql: boolean = false;

  constructor(
    private statusbar: StatusbarService,
  ) {
    statusbar.applyRouteStyle();
  }
}
